import './Legend.component.css'

import PropTypes from 'prop-types'
import React from 'react'
import { SampleContainerComponent } from '../SampleContainer/SampleContainer.component'
import { Stage } from 'react-konva'
import { connect } from 'react-redux'

// css

/**
 * Menu class which is used to render the app main top menu
 */
export class LegendComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      states: Object.keys(this.props.configuration.sample_container_state_legend),
      res: [],
    }
  }

  componentDidMount() {
    this.setState({
      res: this.renderTruc(),
    })
  }

  renderTruc() {
    const res = []

    this.state.states.forEach(status => {
      res.push(
        <div>
          <Stage width={50} height={50} visible opacity={1}>
            <SampleContainerComponent
              updateSelectedSampleContainerCallBack={() => {}}
              showSamples={false}
              status={status}
              type="unipuck"
              samples={[]}
              configuration={this.props.configuration}
              sample_container_radius={
                this.props.configuration.sample_container_state_legend[status].drawing.sample_container_radius
              }
              sample_container_position_from_top={
                this.props.configuration.sample_container_state_legend[status].drawing
                  .sample_container_position_from_top
              }
              sample_container_position_from_left={
                this.props.configuration.sample_container_state_legend[status].drawing
                  .sample_container_position_from_left
              }
            />
          </Stage>
        </div>
      )
      res.push(<div>{status}</div>)
    })

    return res
  }

  render() {
    const style = {
      'margin-left': '50px',
      width: '70px',
      height: '300px',
    }

    return <div style={style}>{this.state.res}</div>
  }
}

export default connect()(LegendComponent)

LegendComponent.propTypes = {
  configuration: PropTypes.object,
  sample_container_radius: PropTypes.number,
  sample_container_position_from_top: PropTypes.number,
  sample_container_position_from_left: PropTypes.number,
  sample_container_background_color: PropTypes.string,
  sample_container_border_color: PropTypes.string,
  sample_container_border_size: PropTypes.number,
}
